import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

const useCreatePrestacionModalidadSectorial = () => {
  const [loadingCreatePrestacionModalidadSectorial, setLoadingCreatePrestacionModalidadSectorial] = useState(false);
  const [successCreatePrestacionModalidadSectorial, setSuccessCreatePrestacionModalidadSectorial] = useState(false);
  const [errorCreatePrestacionModalidadSectorial, setErrorCreatePrestacionModalidadSectorial] = useState(null);
  const [dataCreatePrestacionModalidadSectorial, setDataPrestacionModalidadSectorial] = useState(null);

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";

  const apiRecord = new record.RecordService(
    BASE_URL,
    FUNCTIONS_KEY
  );

  // CREATE
  const createPrestacionModalidadSectorial = async (
    userId: string,
    data: any,
    _cb?: (data: any) => void
  ) => {
    setLoadingCreatePrestacionModalidadSectorial(true);
    setSuccessCreatePrestacionModalidadSectorial(false);
    setErrorCreatePrestacionModalidadSectorial(null);

    apiRecord.newSolicitudModalidadSectorial(userId, data)
      .then((res: any) => {
        setLoadingCreatePrestacionModalidadSectorial(false);
        setSuccessCreatePrestacionModalidadSectorial(true);
        setDataPrestacionModalidadSectorial(res.data);
        _cb?.(res.data);
      })
      .catch((err: any) => {
        console.log(err);
        setLoadingCreatePrestacionModalidadSectorial(false);
        setErrorCreatePrestacionModalidadSectorial(err.response?.data);
      });
  };

  return {
    createPrestacionModalidadSectorial,
    loadingCreatePrestacionModalidadSectorial,
    successCreatePrestacionModalidadSectorial,
    errorCreatePrestacionModalidadSectorial,
    dataCreatePrestacionModalidadSectorial
  };
};

export default useCreatePrestacionModalidadSectorial;
